import axios from 'axios';
import Global from '../../js/shared/global';

const $ = jQuery.noConflict();

export function requestCreateBooking(context, payload) {
	axios.post('/wp-json/fws/v1/create_booking', {action: 'create_booking', productId: payload})
		.then((response) => {

			const frequency = Global.readCookie('frequency');
			// select date
			const productId = document.querySelector('.wc-booking-product-id');
			if (response.data.data) {
				productId.setAttribute('value', response.data.data.ID);
			}
			const startDate = Global.readCookie('selectedOneTimeDate');
			const date = new Date(startDate);
			$('.picker.hasDatepicker').datepicker('setDate', date);

			// set time
			const time = Global.readCookie('selectedTime');
			let timeR = '';
			if (time.indexOf('AM') !== -1) {
				timeR = time.toLowerCase().replace('am', 'am');
			}

			if (time.indexOf('PM') !== -1) {
				timeR = time.toLowerCase().replace('pm', 'pm');
			}

			let flag = response.data.isBooking;
			$('a.ui-state-active').on('click', function() {
				$(document).ajaxComplete(function() {
					$('.booking-spaces-left').remove();
					if (flag) {
						let equal = '';
						setTimeout(function() {
							equal = $('.block-picker li.block a').filter(function() {
								let text = $(this).text();
								text = text.replace(/\s/g, '');
								timeR = timeR.replace(/\s/g, '');
								if (text === timeR) {
									return $(this);
								}
							});
							equal.trigger('click');
						}, 500);

						flag = false;
						document.querySelector('.js-btn-loader').classList.remove('active-loader');
						document.querySelector('.js-continue-step-text').classList.remove('active-loader');
						document.querySelector('.js-continue-step').classList.remove('disabled');
					}
				});
			});

			$('a.ui-state-active').trigger('click');
			const inputEndDate = $('#wc_booking_rbwc_recur_end_date');
			inputEndDate.val('');
			if (frequency === 2) {
				// set often
				const multiDates = Global.readCookie('multiDates');
				const often = multiDates.often;
				// const days = multiDates.days;
				const bookPeriod = $('.wc_bookings_field_recur_period');
				const intervalSelect = $('#wc_bookings_field_recur_interval');
				let weekInterval = 1;
				let monthlyInterval = 1;
				if (often === 'twiceAweek' || often === 'weekly') {
					weekInterval = 1;
					bookPeriod.find('#week').trigger('click');
					intervalSelect.val(weekInterval).trigger('change');
				}

				if (often === 'biWeekly') {
					weekInterval = 2;
					bookPeriod.find('#week').trigger('click');
					intervalSelect.val(weekInterval).trigger('change');
				}

				if (often === 'monthly') {
					weekInterval = 4;
					bookPeriod.find('#week').trigger('click');
					intervalSelect.val(weekInterval).trigger('change');
				}

				if (often === 'biMonthly') {
					monthlyInterval = 2;
					bookPeriod.find('#month').trigger('click');
					intervalSelect.val(monthlyInterval).trigger('change');
				}

				// set end date
				let currentYear = new Date().getFullYear();
				currentYear = currentYear + 10;
				inputEndDate.val('31-12-' + currentYear).trigger('change');
			}

		})
		.catch(e => {
			throw e;
		});
}